<!-- 这页之后可能都不要，就不用ngif来替换掉原生滚动了 -->
<!-- h5禁用之后搭配css 去除overflow: hidden效果  -->
<app-scrollbar #scrollbar class="origin-scoll" [disabled]="isH5">
  <ng-container *ngIf="isH5">
    <div class="left-side" [style.width]="isOpen ? '100%' : '0'">
      <app-left-menu *ngIf="isOpen"></app-left-menu>
    </div>
  </ng-container>

  <div class="right-side" [style.width]="isOpenCombinePopup ? '100%' : '0'">
    <app-right-combine-popup *ngIf="isOpenCombinePopup"></app-right-combine-popup>
  </div>
  <div class="member-header" *ngIf="!isH5">
    <div class="member-container">
      <div class="logo">
        <app-logo
          [lockDevice]="'web'"
          [onlineSize]="['auto', '24']"
          [onlineSizeH5]="['auto', '24']"
          [sitSize]="['116', '24']"
          [sitSizeH5]="['97', '24']"
          [clickable]="true"
        ></app-logo>
      </div>
      <div class="member-list">
        <div class="item" [routerLink]="['../member/account', 'overview']">
          <span>{{ isEvening ? ('good_evening' | translate) : ('good_morning' | translate) }}</span>
          <span>{{ userInfo?.userName || userInfo?.uid || '' }}</span>
        </div>
        <div class="item none" [routerLink]="['../member/account', 'notification-center']">
          <i class="icon-mail"></i>
        </div>
        <div class="item" [routerLink]="['../member/bank', 'overview']">
          <span>{{ 'balance' | translate }}</span>
          <app-currency-wallet [onlyBalance]="true"></app-currency-wallet>
        </div>
        <div class="item" (click)="logOut()">
          {{ 'logout' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="member-layout-menu" *ngIf="!isH5">
    <div class="member-container">
      <ng-container *ngFor="let item of memberLayoutMenu; let index = index">
        <div
          class="item"
          [class.active]="selectInedx == index"
          [class.center]="item.center"
          (click)="selectMenu(item, index)"
        >
          <div class="text" *ngIf="!item.center; else centerTemp">{{ item.title | translate }}</div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- <div class="page-title" *ngIf="!isH5">
    <div class="member-container">
      {{ slelectTitle | translate }}
    </div>
  </div> -->

  <div class="page-container">
    <div class="member-container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
  <app-bottom-menu></app-bottom-menu>
  <!-- safety level template -->
  <ng-template #centerTemp>
    <div class="center-wrap">
      <div class="center-circle"></div>
      <div class="percentage">
        <div>
          <span>{{ currenKycStatus === 3 ? 100 : currenKycStatus === 2 ? 60 : currenKycStatus === 1 ? 30 : 0 }}</span
          ><i>%</i>
        </div>
        <div>{{ 'safety_level' | translate }}</div>
      </div>
    </div>
    <div class="detail">
      <p>{{ userInfo?.userName }} {{ 'certification_status' | translate }}</p>
      <div class="Omoveicon-wrap">
        <app-tool-tip>
          <div origin class="Omoveicon" [class.auth]="currenKycStatus" (click)="!currenKycStatus && jumpPage()">
            <div class="Omoveicontext icon-phone">
              <p>{{ 'no_cer' | translate }}</p>
            </div>
          </div>
          <div tooltip class="tooltip-info">
            <div class="tooltip-info-text">{{ (!currenKycStatus ? 'auth_as_soon' : 'pri_ceri') | translate }}</div>
          </div>
        </app-tool-tip>
        <app-tool-tip>
          <div
            origin
            class="Omoveicon"
            [class.auth]="[2, 3].includes(currenKycStatus)"
            (click)="![2, 3].includes(currenKycStatus) && jumpPage()"
          >
            <div class="Omoveicontext icon-basic">
              <p>{{ 'no_cer' | translate }}</p>
            </div>
          </div>
          <div tooltip class="tooltip-info">
            <div class="tooltip-info-text">
              {{ (![2, 3].includes(currenKycStatus) ? 'auth_as_soon' : 'inter_ceri') | translate }}
            </div>
          </div>
        </app-tool-tip>
        <app-tool-tip>
          <div
            origin
            class="Omoveicon"
            [class.auth]="[3].includes(currenKycStatus)"
            (click)="![3].includes(currenKycStatus) && jumpPage()"
          >
            <div class="Omoveicontext icon-location">
              <p>{{ 'no_cer' | translate }}</p>
            </div>
          </div>
          <div tooltip class="tooltip-info">
            <div class="tooltip-info-text">
              {{ (![3].includes(currenKycStatus) ? 'auth_as_soon' : 'ad_ceri') | translate }}
            </div>
          </div>
        </app-tool-tip>
      </div>
    </div>
  </ng-template>
</app-scrollbar>
